/** EvolveRPG — English overrides for the community feature. Fast-play, momentum-driven voice. */
export const communityEvoEn = {
  // CommunityPage
  'community.page.seoDescription':
    'Join the EvolveRPG community: forums, build guides, GM tools, homebrew, and the Hall of Legends.',
  'community.page.eyebrow': 'The Player Base',
  'community.page.intro':
    'Trade tactics, share builds, post homebrew, and rise toward canon. Every post you make earns coins and reputation.',
  'community.page.loading': 'Loading the community…',
  'community.page.recentEmpty': 'It’s quiet here tonight. Start a discussion and get the conversation moving.',
  'community.page.hallBlurb': 'The players who made their names in Montkelian, ranked by what they did there.',
  'community.page.summoningLegends': 'Loading legends…',
  'community.page.sampleNotice': 'Showing sample community content while the live forums come online.',

  // ForumCategoryPage
  'community.category.seoDescription': 'Discussions in the {name} forum on EvolveRPG.',
  'community.category.sampleNotice': 'Showing sample threads while the live forum comes online.',

  // HallOfLegendsPage
  'community.legends.seoDescription': 'The EvolveRPG players who made their names in Montkelian: quests finished, secrets uncovered and streets walked.',
  'community.legends.intro':
    'Here stand the players who made their names in Montkelian: the quests they finished, the secrets they uncovered and the streets they walked. Renown is earned in play.',
  'community.legends.loading': 'Loading the hall…',
  'community.legends.noContributors': 'No legends yet. Post, theorize, and build to claim your place.',
  'community.legends.noPlayers': 'No one has made their name in Montkelian yet. Enter the city to claim your place.',
  'community.legends.noCharacters': 'No characters have been canonized yet. Be the first.',
  'community.legends.sampleNotice': 'Showing sample legends while the live hall comes online.',

  // PostComposer
  'community.composer.placeholder': 'Add your voice to the table…',

  // ThreadPage
  'community.threadPage.loading': 'Loading the thread…',
  'community.threadPage.seoDescription': 'A discussion in the EvolveRPG community forums.',
  'community.threadPage.sampleNotice': 'Showing sample discussion while the live forum comes online.',
}
